module.exports = __webpack_public_path__ + "img/sld_scb_1_t1_dark.4d0ba3c6.svg";